export const getCookie = (name) => {
  if (typeof document !== 'undefined') {
    return (
      (document.cookie ? document.cookie.split('; ') : [])
        .map((cookie) => cookie.split('='))
        .filter((cookie) => cookie[0] === name)
        .map((cookie) => {
          cookie.shift();

          return cookie.join('=');
        })[0] || null
    );
  }

  return null;
};

export const getCookieString = (
  name,
  value,
  expiresDate,
  path = '/',
  domain = null,
  secure = false,
  sameSite = null,
) => {
  return [
    encodeURIComponent(name),
    '=',
    encodeURIComponent(value),
    expiresDate ? '; expires=' + expiresDate.toUTCString() : '',
    path ? '; path=' + path : '',
    domain ? '; domain=' + domain : '',
    sameSite ? '; SameSite=' + sameSite : '',
    secure ? '; Secure' : '',
  ].join('');
};

export const setCookie = (name, value, expiresDate, path = '/', domain = null, secure = false, sameSite = null) => {
  if (typeof document !== 'undefined') {
    document.cookie = getCookieString(name, value, expiresDate, path, domain, secure, sameSite);
  }
};

export const deleteCookie = (name) => {
  setCookie(name, '');
};
